import React, { useState } from 'react';
import { trackEvent } from '../seo/analytics';

const JOB_TYPES = [
  'Air conditioning',
  'Extension',
  'Loft conversion',
  'Renovation',
  'Kitchen',
  'Bathroom',
  'Roofing',
  'Maintenance',
  'Porch or outbuilding',
  'Other',
];

const SOURCES = [
  'Google search',
  'Google Maps',
  'Recommendation',
  'ChatGPT / AI assistant',
  'Bark',
  'Other',
];

const EnquiryForm = () => {
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    if (data.get('company')) {
      setStatus('sent');
      return;
    }

    if (!data.get('name') || !data.get('phone') || !data.get('email')) {
      setError('Please add your name, phone and email so we can reply.');
      return;
    }

    setStatus('sending');
    setError('');

    try {
      const body = new URLSearchParams(data).toString();
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });

      if (!response.ok) {
        throw new Error('Form endpoint rejected the enquiry');
      }

      trackEvent('form_submit', { job_type: data.get('job-type'), source: data.get('source') });
      setStatus('sent');
      form.reset();
    } catch (err) {
      setStatus('idle');
      setError(
        'The form could not be sent. Please call 0203 576 5962 or email info@fallowbuildingservices.co.uk.'
      );
    }
  };

  if (status === 'sent') {
    return (
      <div className="enquiry-success" role="status">
        <h3>Enquiry received</h3>
        <p>
          Thank you. We aim to reply the same working day, and to book a site
          survey within two working days where the job suits us.
        </p>
      </div>
    );
  }

  return (
    <form
      name="enquiry"
      method="POST"
      data-netlify="true"
      netlify-honeypot="company"
      action="/contact"
      className="enquiry-form"
      onSubmit={onSubmit}
    >
      <input type="hidden" name="form-name" value="enquiry" />
      <p className="enquiry-honeypot">
        <label>
          Company
          <input name="company" tabIndex="-1" autoComplete="off" />
        </label>
      </p>

      <div className="enquiry-grid">
        <label>
          Name
          <input name="name" type="text" required autoComplete="name" />
        </label>
        <label>
          Phone
          <input name="phone" type="tel" required autoComplete="tel" />
        </label>
        <label>
          Email
          <input name="email" type="email" required autoComplete="email" />
        </label>
        <label>
          Postcode
          <input name="postcode" type="text" autoComplete="postal-code" />
        </label>
        <label>
          Job type
          <select name="job-type" defaultValue="Air conditioning">
            {JOB_TYPES.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </label>
        <label>
          Timescale
          <select name="timescale" defaultValue="Not sure yet">
            <option>As soon as possible</option>
            <option>Within a month</option>
            <option>One to three months</option>
            <option>Planning stage</option>
            <option>Not sure yet</option>
          </select>
        </label>
        <label>
          How did you hear about us?
          <select name="source" defaultValue="Google search">
            {SOURCES.map((source) => (
              <option key={source} value={source}>
                {source}
              </option>
            ))}
          </select>
        </label>
      </div>

      <label>
        Message
        <textarea
          name="message"
          rows="5"
          placeholder="Property address, what you want done, and any planning questions. For air conditioning, tell us how many rooms. Photos help us quote faster."
        />
      </label>

      {error && (
        <p className="enquiry-error" role="alert">
          {error}
        </p>
      )}

      <button type="submit" className="enquiry-submit" disabled={status === 'sending'}>
        {status === 'sending' ? 'Sending…' : 'Request a free site survey'}
      </button>
      <p className="enquiry-note">
        We reply the same working day wherever we can. Surveys are booked for
        the next available slot, usually within two working days.
      </p>
    </form>
  );
};

export default EnquiryForm;
